export default __webpack_public_path__ + "static/media/fundo-rosa-cima.995b749d.png";